import { render } from "./TableOrders.vue?vue&type=template&id=030851e9"
import script from "./TableOrders.vue?vue&type=script&lang=ts"
export * from "./TableOrders.vue?vue&type=script&lang=ts"
script.render = render

export default script